<div class="text-center py-48">
    <p class="text-l my-40">
        {{ 'dev.shopcart.maxItems' | translate }}
    </p>
    <!-- El texto de este botón se envía para la analítica, si se cambia aquí también debe cambiarse ahí (Buscar: REF-AN-3)  -->
    <button class="btn btn-primary" (click)="goToShopcart()">{{ 'dev.cart.goToShopcart' | translate }}</button>
</div>
